module.exports = __webpack_public_path__ + "9284634c789ae8bb43b3e22316820e4f.png";